

import React from 'react';
import { streetTypesList } from 'const/streetTypes';
import { isMobile } from 'react-device-detect';
import isEmail from 'validator/lib/isEmail';
import { View } from '@coinscrap/webapp-core';

import InputLabel from 'components/InputLabel/InputLabel';
import { OptionButton } from 'components/OptionButton/OptionButton';

import { gendersList } from '../../../const/genders';
import * as S from './styles';

export const PersonalDataInputs = ({
	name,
	setName,
	surname1,
	setSurname1,
	surname2,
	setSurname2,
	gender,
	setGender,
	municipality,
	setMunicipality,
	addressStreetType,
	setAddressStreetType,
	addressStreetName,
	setAddressStreetName,
	addressNumber,
	setAddressNumber,
	addressFloor,
	setAddressFloor,
	addressDoor,
	setAddressDoor,
	email,
	setEmail,
	isEmailCorrect,
	setIsEmailCorrect,
	phoneNumber,
	setPhoneNumber,
}) => {
	return (
		<>
			<View inputFreeRowSt>
				<InputLabel
					style={{
						marginTop: -10,
						maxWidth: isMobile ? 'none' : 300,
					}}
					value={name}
					onChange={(e) => {
						setName(e.target.value);
					}}
					label={'Nombre'}
				/>
				<InputLabel
					style={{
						marginTop: -10,
						maxWidth: isMobile ? 'none' : 300,
					}}
					value={surname1}
					onChange={(e) => {
						setSurname1(e.target.value);
					}}
					label={'Apellido 1'}
				/>
				<InputLabel
					style={{
						marginTop: -10,
						maxWidth: isMobile ? 'none' : 300,
					}}
					value={surname2}
					onChange={(e) => {
						setSurname2(e.target.value);
					}}
					label={'Apellido 2'}
				/>
			</View>

			<View inputFreeRowSt style={{ marginTop: -10 }}>
				<InputLabel type="custom" label={'Sexo'}>
					<View
						rowSt
						justifyStartSt
						style={{
							gap: isMobile ? '20px' : '12px',
							flexWrap: 'wrap',
						}}
					>
						{gendersList.map((gen) => (
							<OptionButton
								key={gen.VALUE}
								onClick={() => setGender(gen.VALUE)}
								selected={gender === gen.VALUE}
								text={gen.NAME}
								style={{
									width: isMobile ? '100%' : undefined,
									margin: isMobile ? 0 : undefined,
								}}
							/>
						))}
					</View>
				</InputLabel>
			</View>

			<View inputFreeRowSt>
				{/* <InputLabel
					style={{
						marginTop: -10,
						maxWidth: isMobile ? 'none' : 300,
					}}
					value={municipality || ''}
					onChange={(value) => {
						setMunicipality(value);
					}}
					label={'Población'}
					type="autoSuggest"
					disabled
					selectOptions={municipalitiesList.map((item) => {
						return {
							label: item.NOMBRE,
							value: item.NOMBRE,
						};
					})}
				/> */}
				<InputLabel
					style={{
						marginTop: -10,
						maxWidth: isMobile ? 'none' : 300,
					}}
					value={addressStreetType || 0}
					onChange={(e) => {
						setAddressStreetType(e.target.value);
					}}
					label={'Tipo de vía'}
					type="select"
					selectOptions={streetTypesList.map((item) => {
						return {
							label: item.NAME,
							value: item.VALUE,
						};
					})}
				/>
			</View>

			<View inputFreeRowSt>
				<InputLabel
					style={{
						marginTop: -10,
						maxWidth: isMobile ? 'none' : 300,
					}}
					value={addressStreetName}
					onChange={(e) => {
						setAddressStreetName(e.target.value);
					}}
					label={'Nombre de la vía'}
				/>
				<S.MinInputsWraper>
					<InputLabel
						style={{
							marginTop: -10,
							maxWidth: isMobile ? 'calc(33.33% - 14px)' : 142,
						}}
						value={addressNumber}
						onChange={(e) => {
							setAddressNumber(e.target.value);
						}}
						label={'Número'}
					/>
					<InputLabel
						style={{
							marginTop: -10,
							maxWidth: isMobile ? 'calc(33.33% - 14px)' : 142,
						}}
						value={addressFloor}
						onChange={(e) => {
							setAddressFloor(e.target.value);
						}}
						label={'Piso'}
					/>
					<InputLabel
						style={{
							marginTop: -10,
							maxWidth: isMobile ? 'calc(33.33% - 14px)' : 142,
						}}
						value={addressDoor}
						onChange={(e) => {
							setAddressDoor(e.target.value);
						}}
						label={'Puerta'}
					/>
				</S.MinInputsWraper>
			</View>

			<View inputFreeRowSt>
				<InputLabel
					onBlur={() => {
						setIsEmailCorrect(isEmail(email));
					}}
					value={email}
					onChange={(e) => {
						if (!isEmailCorrect) {
							setIsEmailCorrect(isEmail(e.target.value));
						}
						setEmail(e.target.value);
					}}
					label={'Correo electrónico'}
					errorMsg={!isEmailCorrect && `Correo electrónico inválido`}
					style={{ marginTop: -10 }}
				/>
			</View>

			<View inputFreeRowSt>
				<InputLabel
					value={phoneNumber}
					onChange={(value) => {
						setPhoneNumber(value);
					}}
					label={'Teléfono móvil'}
					type="phone"
					style={{ marginTop: -10 }}
				/>
			</View>
		</>
	);
};
